import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moIndex from '../../store/index';
import moDifferent from './store';
import TablePDF from './table-pdf';

interface IProps {}
interface IState {}

const CityDiffPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { list1, lists } = moDifferent;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      {!isEmpty(list1) ? <TablePDF list={list1} page={1} /> : null}
      {lists.map((arr: any, index: number) => (
        <TablePDF key={index} list={arr} page={index + 2} />
      ))}
    </>
  );
};

export default observer(CityDiffPDF);
